import { render, staticRenderFns } from "./CompetencySpread.vue?vue&type=template&id=a4eafaae&scoped=true"
import script from "./CompetencySpread.vue?vue&type=script&lang=ts"
export * from "./CompetencySpread.vue?vue&type=script&lang=ts"
import style0 from "./CompetencySpread.vue?vue&type=style&index=0&id=a4eafaae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4eafaae",
  null
  
)

export default component.exports